import { Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { forEach } from "async";
import { CaseAddresses } from "../classes/caseAddresses";

@Injectable({
    providedIn: 'root'
})
export class URLLinkingService
{
    hasArguments: boolean = false;
    urlParameterNames: string[] = [];
    urlParamaterMapping: Map<string, string> = new Map();

    constructor() 
    {
        this.urlParameterNames = [
            "CaseRef",
            "UPRN",
            "Organisation",
            "SubBuildingName",
            "Paon",
            "Saon",
            "BuildingName",
            "BuildingNumber",
            "Street",
            "Locality",
            "TownCity",
            "County",
            "Postcode",
            "Country",
            "Easting",
            "Northing",
            "PropertyType",
            "Toid",
            "DependantThoroughfareName",
            "DependantThoroughfareDescriptor",
            "ThoroughfareDescriptor",
            "DoubleDependantLocality"
        ];
    }

    loadFromURL() 
    {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        var params = [];
        urlParams.forEach((v, k, p) => {
            var key = k.toLowerCase();
            var exists: boolean = false;
            for (var i = 0; i < this.urlParameterNames.length; i++)
            {
                if (key == this.urlParameterNames[i].toLowerCase())
                {
                    exists = true;
                }
            }

            if (exists)
            {
                this.hasArguments = true;
                this.urlParamaterMapping.set(key, v);
            }
        });

    }

    getUrlArgument(paramName: string):string
    {
        if (this.hasArguments)
        {
            return this.urlParamaterMapping.get(paramName.toLowerCase());
        }

        return null;
    }

    clear()
    {
        this.hasArguments = false;
        this.urlParamaterMapping.clear();
    }

    public asCaseAddresses(): CaseAddresses
    {

        var _buildingname: string       = this.getUrlArgument("BuildingName");
        var _buildingnumber: string     = this.getUrlArgument("BuildingNumber");
        var _country: string            = this.getUrlArgument("Country");
        var _county: string             = this.getUrlArgument("County");
        var _caseaddressid: number      = 0;
        var _casefileid: number         = 0;
        var _locality: string           = this.getUrlArgument("Locality");
        var _organization: string       = this.getUrlArgument("Organisation");
        var _postcode: string           = this.getUrlArgument("Postcode");
        var _throughfare: string        = this.getUrlArgument("DependantThoroughfareName");
        var _street: string             = this.getUrlArgument("Street");
        var _subbuildingName: string    = this.getUrlArgument("SubBuildingName");
        var _towncity: string           = this.getUrlArgument("TownCity");
        var _uprn: string               = this.getUrlArgument("UPRN");
        var _northing: number           = +this.getUrlArgument("Northing");
        var _easting: number            = +this.getUrlArgument("Easting");

        return new CaseAddresses(_buildingname, _buildingnumber, _country, _county, _caseaddressid, _casefileid, _locality,
            _organization, _postcode, _throughfare, _throughfare, _street, _subbuildingName, _towncity, _uprn, _northing, _easting);
    }
}
